import ApiService from './ApiService'

export const getApiData = (data) => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map((sort) => {
            if (!sort.order) return sort
            datas.ordering =
                sort.order === 'desc' ? `-${sort.key}` : `${sort.key}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.status = data.selectedTab
        }
    }
    return ApiService.get('/rate-card-template/template-formula/', datas)
}
export const createApiRecord = (data) =>
    ApiService.filePost('/rate-card-template/template-formula/', data)
export const getApiRecord = (id) =>
    ApiService.get(`/rate-card-template/template-formula/${id}`)
export const updateApiRecord = (id, data) =>
    ApiService.patch(`/rate-card-template/template-formula/${id}/`, data)
export const updateApiStatus = (id, data) =>
    ApiService.patch(`/rate-card-template/template-formula/${id}/`, data)
export const deleteApiRecord = (id) =>
    ApiService.delete('/rate-card-template/template-formula', id)
